module.exports = __webpack_public_path__ + "assets/round-checkbox-on.4c8929fd.svg";